// extracted by mini-css-extract-plugin
export var footer = "_of-0";
export var inherit = "_of-1";
export var input = "_of-2";
export var modalContent = "_of-3";
export var quillEditor = "_of-4";
export var subtitle = "_of-5";